module.exports = __webpack_public_path__ + "static/media/2025_Illit.a1aa6ede.png";